module.exports = __webpack_public_path__ + "static/img/veg_crate.3593d8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/veg_crate.jpg
// module id = 5dLR
// module chunks = 1